import { Outlet, useLocation } from "react-router-dom";
import { AppLayout } from "@/components/AppLayout";
import { ChannelsProvider } from "@/components/ChannelsProvider";
import { EventStreamProvider } from "@/components/EventStreamProvider";
import { LiveQuerySync } from "@/components/LiveQuerySync";
import { useSignOutWhenSessionEnds } from "@/hooks/useSignOutWhenSessionEnds";

// Routes that need a full-height, flex-based layout without main padding
// (e.g. chat, which manages its own scroll regions).
const NO_PADDING_ROUTES = ["/chat"];

export function ProtectedShell() {
  const { pathname } = useLocation();
  useSignOutWhenSessionEnds();
  const noPadding = NO_PADDING_ROUTES.some((r) => pathname === r || pathname.startsWith(`${r}/`));
  return (
    <EventStreamProvider>
      <ChannelsProvider>
        <LiveQuerySync />
        <AppLayout noPadding={noPadding}>
          <Outlet />
        </AppLayout>
      </ChannelsProvider>
    </EventStreamProvider>
  );
}
